export default "__VITE_ASSET__b6412178__"